import { render } from "./contentAnalysis.vue?vue&type=template&id=6440b08c&scoped=true"
import script from "./contentAnalysis.vue?vue&type=script&lang=js"
export * from "./contentAnalysis.vue?vue&type=script&lang=js"

import "./contentAnalysis.vue?vue&type=style&index=0&id=6440b08c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6440b08c"]])

export default __exports__